/**
 * Training duration selector component
 */

import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "@/hooks/useTranslation";
import { Badge } from "@/components/ui/badge";
import type { TreningSluzba } from "../../types";

interface TrainingDurationSelectProps {
  pocetOsob: "1" | "2" | "3-6";
  value: number | null;
  options: TreningSluzba[];
  onChange: (treningId: number) => void;
}

export function TrainingDurationSelect({
  pocetOsob,
  value,
  options,
  onChange,
}: TrainingDurationSelectProps) {
  const { t } = useTranslation();
  const filteredOptions = options.filter(
    opt => opt.pocetOsob === pocetOsob && opt.aktivna
  );

  return (
    <div className="space-y-2">
      <Label>{t("attendance:dialog.trainingDuration")}</Label>
      <Select
        value={value?.toString() || ""}
        onValueChange={val => onChange(parseInt(val))}
      >
        <SelectTrigger>
          <SelectValue placeholder={t("attendance:dialog.selectDuration")} />
        </SelectTrigger>
        <SelectContent>
          {filteredOptions.map(option => (
            <SelectItem key={option.id} value={option.id.toString()}>
              <div className="flex justify-between items-center w-full gap-4">
                <span>{option.nazov}</span>
                <Badge variant="secondary">
                  {Number(option.cena).toFixed(2)} €
                </Badge>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
